import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { AboutSection, Avatar, Title, Text, SubTitle } from "./style"
import { SectionIntro, ContainerLayout, ResumeButton } from "../common"
import { Link } from "gatsby"

const About = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "profile.png" }) {
        childImageSharp {
          fluid(maxWidth: 550) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <>
      <SectionIntro>
        <ContainerLayout>
          <AboutSection>
            <div>
              <Avatar
                fluid={data.placeholderImage.childImageSharp.fluid}
                alt="user photo"
              />
              <SubTitle>Full Stack Developer</SubTitle>
            </div>
            <div>
              <Title> Hi, I'm Facundo</Title>
              <Text>
                {" "}
                I'm a backend developer with a knack for data science and
                AI-Powered Systems. I mostly use{" "}
                <b className="text-primary lined-link">Python</b> for my coding
                needs.
              </Text>
              <Text>
                {" "}
                I also create user interfaces with{" "}
                <b className="text-primary lined-link">ReactJS</b>, making apps
                fast and easy to use.
              </Text>{" "}
              <Text>
                I've got a good handle on a bunch of technologies, including:
                &nbsp;
                <b className="text-primary lined-link">Python</b>,{" "}
                <b className="text-primary lined-link">Langchain</b>,{" "}
                <b className="text-primary lined-link">ReactJS</b>,{" "}
                <b className="text-primary lined-link">MongoDB</b>,{" "}
                <b className="text-primary lined-link">PostgreSQL</b>, &nbsp;
                <b className="text-primary lined-link">Redis</b>,{" "}
                <b className="text-primary lined-link">Django</b>,
                <b className="text-primary lined-link">Pandas and GeoPandas</b>,{" "}
              </Text>
              <Link to="/works" target="_blank">
                {" "}
                Check out some of my works{" "}
              </Link>
              <a
                href="/pdf/resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download my resume
              </a>
            </div>
          </AboutSection>
        </ContainerLayout>
      </SectionIntro>
    </>
  )
}

export default About
